
import $ from 'jquery'
//
Vue.prototype.$jquery = $
window.$ = window.jQuery = $

export default jQuery;
